"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSwitch = exports.Form = exports.FormField = exports.FormFieldTypes = void 0;
var React = require("react");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var react_1 = require("react");
var moment = require("moment");
var config_1 = require("../../config");
var typestyle_1 = require("typestyle");
var datepicker_1 = require("../datepicker");
var FormFieldTypes = (function () {
    function FormFieldTypes() {
    }
    FormFieldTypes.TEXT = "text";
    FormFieldTypes.TEXTAREA = "textarea";
    FormFieldTypes.SELECT = "select";
    FormFieldTypes.DATE = "date";
    FormFieldTypes.FILE = "file";
    return FormFieldTypes;
}());
exports.FormFieldTypes = FormFieldTypes;
var FormField = function (props) {
    var _a = __read((0, react_1.useState)(props.value.toString()), 2), currentValue = _a[0], setValue = _a[1];
    var inputField = null;
    var errors = props.errors && props.errors[props.name];
    var fieldClasses = (0, typestyle_1.classes)("form-control", props.inputClasses);
    if (errors)
        fieldClasses += " is-invalid";
    if (props.type == FormFieldTypes.TEXTAREA) {
        inputField = (React.createElement("textarea", __assign({}, props, { className: fieldClasses, value: props.onChange ? props.value : currentValue, onChange: function (e) {
                props.onChange ? props.onChange(e) : setValue(e.currentTarget.value);
            } })));
    }
    else if (props.type == FormFieldTypes.SELECT) {
        if (props.choices) {
            inputField = (React.createElement(generic_1.ChoiceSelect, { className: fieldClasses, choices: props.choices, id: props.id, name: props.name, value: props.onChange ? props.value : currentValue, onChange: function (e) {
                    props.onChange ? props.onChange(e) : setValue(e.currentTarget.value);
                } }));
        }
    }
    else if (props.type == FormFieldTypes.DATE) {
        var datePickerRef = React.createRef();
        inputField = (React.createElement(datepicker_1.default, { id: props.id, name: props.name, ref: datePickerRef, selected: currentValue ? moment(currentValue, config_1.ISO_DATE_FORMAT) : null, onChange: function (date) {
                setValue(date ? date.format(config_1.ISO_DATE_FORMAT) : null);
            } }));
    }
    else if (props.type == FormFieldTypes.FILE) {
        inputField = (React.createElement("div", null,
            React.createElement("div", { className: "custom-file" },
                React.createElement("input", { type: props.type, name: props.name, accept: props.accept, id: props.id, className: "custom-file-input" }),
                React.createElement("label", { htmlFor: props.id, className: "custom-file-label" }, gettext("Choose file"))),
            React.createElement("div", null, props.value &&
                React.createElement(React.Fragment, null,
                    props.value,
                    props.removeFile &&
                        React.createElement(buttons_1.InvisibleButton, { onClick: props.removeFile },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.close_circle }))))));
    }
    else {
        inputField = React.createElement("input", __assign({ className: fieldClasses }, props, { onChange: function (e) {
                return props.onChange ? props.onChange(e) : setValue(e.currentTarget.value);
            }, value: props.onChange ? props.value : currentValue }));
    }
    return (React.createElement(React.Fragment, null, inputField &&
        React.createElement("div", { className: props.containerClasses },
            props.label &&
                React.createElement("label", { className: props.labelClasses, htmlFor: props.id },
                    props.label,
                    ":"),
            React.createElement("div", { className: props.inputContainerClasses },
                inputField,
                errors &&
                    React.createElement("div", { className: "form-invalid" }, errors.map(function (msg) {
                        return React.createElement("p", null, msg);
                    }))))));
};
exports.FormField = FormField;
var Form = function (props) {
    return (React.createElement("form", { className: props.className, method: props.method, encType: props.encType, onSubmit: props.onFormSubmit },
        Object.keys(props.fields).map(function (name) {
            var field = props.fields[name];
            field.errors = __assign(__assign({}, field.errors), props.formErrors);
            return React.createElement(exports.FormField, __assign({ labelClasses: props.labelClasses, inputClasses: props.inputClasses, inputContainerClasses: props.inputContainerClasses, containerClasses: (0, typestyle_1.classes)("form-group", "row") }, field));
        }),
        props.children));
};
exports.Form = Form;
var InputSwitch = function (props) {
    return (React.createElement("div", { className: "custom-control custom-switch" },
        React.createElement("input", { type: "checkbox", id: props.id, className: (0, typestyle_1.classes)("custom-control-input", props.className), checked: props.checked, tabIndex: props.tabIndex, onChange: props.onChange }),
        React.createElement("label", { className: (0, typestyle_1.classes)("custom-control-label", props.labelClasses), htmlFor: props.id }, props.labelText || "")));
};
exports.InputSwitch = InputSwitch;
